module.exports = __webpack_public_path__ + "web.config";


//////////////////
// WEBPACK FOOTER
// ./web.config
// module id = 1218
// module chunks = 0